// Brand assets — single source of truth for the FEC Watchdog logo.
// Update the URL here and every login page, sidebar, learn-more page,
// and marketing surface picks it up automatically.
export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_2dc7e5f0-957b-4764-94c1-222ceafaf4b5/artifacts/xt293n7l_WatchdogLogo2-dark.png";

export const FAVICON_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_2dc7e5f0-957b-4764-94c1-222ceafaf4b5/artifacts/9wgujfap_WatchDog-Favicon.png";
